<template>
  <div class="cropper-page logo-top">
    <div class="logo-topTitle-flexTp">
      <div class="logo-topTitle-flex">
        <div class="logo-topTitle">报告封面配置</div>
        <div class="logo-btn ease" @click="save">保存</div>
      </div>
      <div class="logo-set-cover-c">
        <div class="logo-set-cover logo-set-coverl">
          <div class="cover-top">
            <img
              class="background-cover-top"
              v-if="listData && listData.coverImageShow == 1"
              :src="listData.coverImage"
              alt=""
            />
            <img
              class="background-cover-top"
              v-if="listData && listData.coverImageShow == 0"
              src="https://shuian-file.oss-cn-hangzhou.aliyuncs.com/image/ser.png"
              alt=""
            />
            <div
              class="logo-cover-top"
              :class="{ 'logo-cover-top3': listData.coverStructurePosition == 3 }"
              
              :style="{backgroundImage: 'url('+listData.coverLogoImage+')',backgroundSize:'contain',backgroundRepeat: 'no-repeat'}"
            >
              <!-- <img v-if="listData" :src="listData.coverLogoImage" alt="" /> -->
            </div>
            <div
              class="cover-detected cover-white"
              v-if="listData && listData.coverDisplayCompanyName == 1"
              :class="{ 'logo-cover-detected2': listData.coverStructurePosition != 1, 'logo-black': listData.coverFontColor == 'black' }"
            >
              被检测公司名称
            </div>
              
            <div class="heng" :class="{ 'logo-cover-top2': listData.coverStructurePosition != 1}" v-if="listData && listData.coverDisplayCompanyName == 1"></div>
            <div
              class="cover-detected-back cover-white"
              v-if="listData"
              :class="{ 'logo-cover-detected2': listData.coverStructurePosition != 1, 'logo-black': listData.coverFontColor == 'black' }"
            >
              {{ listData.reportName }}
            </div>
            <!-- <div
              class="cover-report"
              v-if="listData"
              :class="{ 'logo-cover-detected2': listData.coverStructurePosition == 2, 'logo-cover-detected3': listData.coverStructurePosition == 3 }"
            >
              税务体检报告
            </div> -->
            <span
              class="cover-detected-company cover-white"
              :class="{ 'logo-cover-top2': listData.coverStructurePosition != 1, 'logo-black': listData.coverFontColor == 'black' }"
              v-if="listData"
            >
             报告生成日期: {{  coverTime}}
            </span>
            <span
              class="cover-time cover-white"
              :class="{ 'logo-cover-top2': listData.coverStructurePosition != 1, 'logo-black': listData.coverFontColor == 'black' }"
              v-if="listData &&listData.coverAssertor"
            >
              检测机构:{{ listData.coverAssertor }}
            </span>
          </div>
          <div class="logo-reset-logo">
            <div class="logo-top-flex">
              <div class="logo-upload-flexs">
                <div class="logo-upload-title">默认封面配置LOGO</div>
                <div
                  class="logo-buyBrandConfig"
                  v-if="listData && listData.buyBrandConfig == 0"
                  @click="brandPay"
                ></div>
                <el-upload
                  class="logo-upload-box logo-upload-boxImg"
                  action="#"
                  :show-file-list="false"
                  :before-upload="beforeAvatarUpload"
                  :http-request="httpRequest"
                >
                  <div class="avatar-cover" v-if="listData && listData.coverLogoImage">
                    <img :src="listData.coverLogoImage" class="avatar" />
                  </div>
                  <i
                    v-else
                    class="el-icon-plus avatar-uploader-icon avatar-uploader-iconadd"
                  ></i>
                </el-upload>
                <div class="logo-upload-icon">图片要求：</div>
                <div class="logo-upload-iconpng">png格式，不超过2M</div>
              </div>
            </div>
            <div class="logo-upload-flexs logo-label">
              <div class="label-name">检测对象设置</div>
              <div v-if="listData">
                <el-checkbox
                  true-label="1"
                  false-label="0"
                  v-model="listData.coverDisplayCompanyName"
                  @change="changeDisplayCompanyName"
                  >显示被检测公司的名称
                </el-checkbox>
              </div>
            </div>
            <!--  -->
            <div class="logo-upload-flexs logo-label">
              <div class="label-name">报告名称设置</div>
              <div v-if="listData">
                <el-input
                  v-model="listData.reportName"
                  placeholder="请输入内容"
                  maxlength="8"
                  show-word-limit
                ></el-input>
              </div>
            </div>
            <!--  -->
            <div class="logo-upload-flexs logo-label">
              <div class="label-name">封面字体颜色配置</div>
              <div>
                <el-radio v-model="listData.coverFontColor" label="black">黑色</el-radio>
                <el-radio v-model="listData.coverFontColor" label="white">白色</el-radio>
              </div>
            </div>
            <!--  -->
            <div class="logo-upload-flexs logo-label">
              <div class="label-name">检测机构名称设置</div>
              <div v-if="listData">
                <el-input
                  v-model="listData.coverAssertor"
                  placeholder="请输入内容"
                  :disabled="listData.buyBrandConfig == 0"
                ></el-input>
              </div>
            </div>

            <div class="cover-flex">
              <div class="cover-flex1">
                <cover-top @coverTop="coverTop" :listData="this.listData"></cover-top>
              </div>
            </div>
            <div class="logo-upload-flexs logo-label">
              <div>封面结构视图</div>
              <div>
                <el-radio v-model="listData.coverStructurePosition" :label="1"
                  >居左</el-radio
                >
                <el-radio v-model="listData.coverStructurePosition" :label="2"
                  >居中</el-radio
                >
                <el-radio v-model="listData.coverStructurePosition" :label="3"
                  >居右</el-radio
                >
              </div>
            </div>
          </div>
        </div>
        <div class="logo-set-cover logo-set-coverr">
          <div class="cover-top">
            <img
              class="background-cover-top"
              v-if="listData && listData.backCoverImageShow == 1"
              :src="listData.backCoverImage"
              alt=""
            />
            <img
              class="background-cover-top"
              v-if="listData && listData.backCoverImageShow == 0"
              src="http://shuian-file.oss-cn-hangzhou.aliyuncs.com/user/logo-back.png"
              alt=""
            />
          </div>
          <div class="logo-reset-logo">
            <div class="cover-flex">
              <div class="cover-flex1">
                <cover-bottom
                  @coverBottom="coverBottom"
                  :listData="this.listData"
                ></cover-bottom>
              </div>
            </div>
          </div>
        </div>
        <div class="reset-tip">
          温馨提示：配置完成后，新的检测报告将按配置要求展示，配置前的检测报告维持原样。
        </div>
      </div>
    </div>

    <div id="demo">
      <!-- 遮罩层 -->
      <div class="container" v-show="panel">
        <div class="cropper-box">
          <img id="image" :src="url" alt="Picture" />
        </div>
        <div class="bottom-btn-box">
          <button type="button" class="del-btn" @click="stopCrop">取消</button>
          <button type="button" class="sure-btn" @click="crop">确定</button>
        </div>
      </div>

      <div class="cropper-warpper">
        <input
          type="file"
          id="change"
          ref="file"
          :value="filevalue"
          class="cropper-hidden"
          accept="image"
          @change="change"
        />
        <label class="cropper-label" for="change">
          <slot></slot>
        </label>
      </div>
    </div>

    <!-- <div class="cover-flex1">

        </div> -->
  </div>
</template>
<script>
import Cropper from "cropperjs";
import coverTop from "./coverTop";
import coverBottom from "./coverBottom";
import { editLogo, uploadToOss, getLogo } from "@/api/api";

const moment = require("moment");

export default {
  props: {
    quality: Number,
    default: 1,
  },
  components: { coverTop, coverBottom },
  data() {
    return {
      dataImg: "",
      coverBottomImg: "",
      coverTopImg: "",
      uploadLogoImg: "",
      uploadLogo: null,
      headerImage: "",
      picValue: "",
      cropper: "",
      croppable: false,
      panel: false,
      url: "",
      filevalue: "",
      listData: {},
      detected: 0,
      detectedName: "税安科技（杭州）有限公司",
      coverTime: "",
    };
  },
  mounted() {
    this.getlogo();
    //初始化这个裁剪框
    var self = this;
    var image = document.getElementById("image");
    this.cropper = new Cropper(image, {
      aspectRatio: 8 / 3,
      viewMode: 1,
      background: false,
      zoomable: false,
      modal: false,
      ready: function () {
        self.croppable = true;
      },
    });
  },
  methods: {
    brandPay() {
      if (this.listData.buyBrandConfig == 0) {
        this.$alert(
          "检测报告封面和封底的配置需要为增值服务，如有需要，请联系我们购买。<br><strong>服务热线：0571-85055930</strong><br>服务时间：每周一至周五  9:00-17:30",
          "温馨提示",
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "关闭",
          }
        );
      }
    },
    changeDisplayCompanyName() {
      this.brandPay();
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isJPG) {
        this.$message.error("上传logo只能是 PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传logo大小不能超过 5MB!");
      }
      return isJPG && isLt2M;
    },
    httpRequest(data) {
      let _this = this;
      let rd = new FileReader(); // 创建文件读取对象
      let file = data.file;
      rd.readAsDataURL(file); // 文件读取装换为base64类型
      rd.onloadend = function (e) {
        _this.uploadLogoImg = this.result; // this指向当前方法onloadend的作用域
        _this.dataImg = _this.uploadtoOss(this.result);
      };
    },
    getlogo() {
      getLogo(localStorage.getItem("authorization")).then((res) => {
        this.listData = res.data;
        // this.listData.buyBrandConfig = 1;
        this.listData.coverDisplayCompanyName = String(
          this.listData.coverDisplayCompanyName
        );
        // console.log(this.listData);
        // if (this.listData) {
        //   this.uploadLogoImg = this.listData.coverLogoImage;
        //   this.uploadLogo = true;
        //   this.dataImg = res.data.coverLogoImage;
        //   this.coverTopImg = res.data.coverImage;
        //   this.coverBottomImg = res.data.backCoverImage;
        // }
        let time = new Date().valueOf();
        this.coverTime = moment(time).format("YYYY-MM-DD");
        // console.log(this.coverTime);
      });
    },
    coverTop(val) {
      this.listData.coverImage = val;
    },
    coverBottom(val) {
      this.listData.backCoverImage = val;
    },
    // 点击上传按钮
    upload() {
      // this.$refs['file'].change()
      this.$refs["file"].dispatchEvent(new MouseEvent("click"));
    },
    getObjectURL(file) {
      var url = null;
      if (window.createObjectURL != undefined) {
        // basic
        url = window.createObjectURL(file);
      } else if (window.URL != undefined) {
        // mozilla(firefox)
        url = window.URL.createObjectURL(file);
      } else if (window.webkitURL != undefined) {
        // webkit or chrome
        url = window.webkitURL.createObjectURL(file);
      }
      // console.log(url);
      return url;
      // console.log(url);
    },
    change(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.panel = true;
      this.picValue = files[0];
      this.url = this.getObjectURL(this.picValue);
      // //每次替换图片要重新得到新的url
      // if (this.cropper) {
      //   this.cropper.replace(this.url);
      // }
      // this.panel = true;
      //对图片压缩处理
      let img_size = this.picValue.size;
      this.filename = this.picValue.name;
      let render = new FileReader();
      render.readAsDataURL(this.picValue);
      render.onload = (e) => {
        if (img_size >= 2600 * 2600 * 0.2) {
          this.$message.error("图片过大，请选择2600*2600像素以内的图片");
          //调用自定义方法来处理图片
          this.compressImage(e.target.result);
        } else {
          this.url = this.getObjectURL(this.picValue);
          //每次替换图片要重新得到新的url
          if (this.cropper) {
            this.cropper.replace(this.url);
          }
          this.panel = true;
        }
      };

      // this.$vux.loading.show();
    },
    dataURLtoFile(dataurl, filename) {
      //将base64转换为文件
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    compressImage: function (bdata) {
      //压缩图片
      var _this = this;
      var quality = 0.6; //压缩图片的质量
      var oldimglength = bdata.length; //压缩前的大小
      var compresRadio = 0; // 压缩率

      var canvas = document.createElement("canvas"); //创建画布
      var ctx = canvas.getContext("2d");

      var img = new Image();
      img.src = bdata;
      img.onload = function () {
        var width = img.width;
        var height = img.height;
        canvas.width = 100; //这里可以自定义你的图片大小
        canvas.height = 100 * (img.height / img.width);
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        var cdata = canvas.toDataURL("image/jpeg", quality); //将图片转为Base64 之后预览要用

        // _this.HeadUrl = cdata; //预览你压缩后的图片
        var newimglength = cdata.length;

        compresRadio =
          (((oldimglength - newimglength) / oldimglength) * 100).toFixed(2) + "%";

        //base64转成file
        let arr = cdata.split(",");
        let mime = arr[0].match(/:(.*?);/)[1];
        let bstr = atob(arr[1]);
        let n = bstr.length;
        let u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        let newFile = new File([u8arr], _this.filename, { type: mime });
        //  console.log(this.picValue)
        _this.url = _this.getObjectURL(newFile);
        //每次替换图片要重新得到新的url
        if (_this.cropper) {
          _this.cropper.replace(this.url);
        }
        _this.panel = true;
      };
    },

    stopCrop() {
      this.panel = false;
    },
    crop() {
      // let quality = 0.3
      // this.$vux.loading.show();
      var croppedCanvas;
      var roundedCanvas;
      if (!this.croppable) {
        return;
      }
      // Crop
      croppedCanvas = this.cropper.getCroppedCanvas();
      // Round
      roundedCanvas = this.getRoundedCanvas(croppedCanvas);

      this.headerImage = roundedCanvas.toDataURL("image/png", this.quality);
      // this.$emit("getUrlBase64", this.headerImage);
      this.dataImg = this.uploadtoOss(this.headerImage);
      // this.$emit("getUrlBase64", this.dataImg);
      // let dataImg = this.dataURLtoFile(this.headerImage, "logo");
      this.uploadLogo = true;
      this.uploadLogoImg = this.headerImage;

      // this.$vux.loading.hide();
      this.panel = false;
    },
    getRoundedCanvas(sourceCanvas) {
      var canvas = document.createElement("canvas");
      var context = canvas.getContext("2d");
      var width = sourceCanvas.width;
      var height = sourceCanvas.height;

      canvas.width = width;
      canvas.height = height;

      context.imageSmoothingEnabled = true;
      context.drawImage(sourceCanvas, 0, 0, width, height);
      context.globalCompositeOperation = "destination-in";
      context.beginPath();
      //圆形
      // context.arc(
      //   width / 2,
      //   height / 2,
      //   Math.min(width, height) / 2,
      //   0,
      //   2 * Math.PI,
      //   true
      // );
      //矩形
      context.rect(0, 0, width, height);
      context.fill();
      return canvas;
    },

    uploadtoOss(img) {
      let params = {
        imgBase: img,
      };
      uploadToOss(params, localStorage.getItem("authorization")).then((res) => {
        if (res.msgCode == 1) {
          this.listData.coverLogoImage = res.data;
        } else {
          this.$message.error(res.msgInfo);
          return;
        }
      });
    },

    save() {
      if (this.listData.buyBrandConfig == 0) {
        this.$alert(
          "检测报告封面和封底的配置需要为增值服务，如有需要，请联系我们购买。<br><strong>服务热线：0571-85055930</strong><br>服务时间：每周一至周五  9:00-17:30",
          "温馨提示",
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "关闭",
          }
        );
      } else {
        this.editlogo();
      }
    },

    editlogo() {
      //
      if (this.listData.coverImageShow == 1 && !this.listData.coverImage) {
        this.$message({
          message: "请上传新的封面！",
          type: "warning",
        });
        return;
      }
      if (this.listData.backCoverImageShow == 1 && !this.listData.backCoverImage) {
        this.$message({
          message: "请上传新的封底！",
          type: "warning",
        });
        return;
      }
      //
      let params = {
        coverLogoImage: this.listData.coverLogoImage,
        coverImage: this.listData.coverImage,
        backCoverImage: this.listData.backCoverImage,
        coverDisplayCompanyName: this.listData.coverDisplayCompanyName,
        coverAssertor: this.listData.coverAssertor,
        id: this.listData.id,
        coverStructurePosition: this.listData.coverStructurePosition,
        coverImageShow: this.listData.coverImageShow,
        backCoverImageShow: this.listData.backCoverImageShow,
        reportName: this.listData.reportName,
        coverFontColor: this.listData.coverFontColor
      };
      editLogo(params, localStorage.getItem("authorization")).then((res) => {
        if (res.msgCode == 1) {
          this.$notify({
            title: "温馨提示",
            message: "保存成功！",
            type: "success",
          });
          this.getlogo();
        } else {
          this.$message({
            message: res.msgInfo,
            type: "warning",
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>

.cropper-page {
  .cropper-warpper {
    display: flex;
    align-items: center;
  }

  .cropper-box {
    width: 100%;
    height: 80%;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }

  #demo #button {
    position: absolute;
    right: 10px;
    top: 10px;
    width: 80px;
    height: 40px;
    border: none;
    border-radius: 5px;
    background: white;
  }

  .bottom-btn-box {
    display: flex;
    justify-content: space-between;
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 0;

    button {
      outline: none;
      border: none;
      padding: 5px 20px;
      border-radius: 2px;
      font-size: 16px;
      color: #fff;
      background: #f05b47;
      margin: 15px;

      &.del-btn {
        background: #aaa;
      }
    }
  }

  #demo .show {
    width: 100px;
    height: 100px;
    overflow: hidden;
    position: relative;
    border-radius: 50%;
    border: 1px solid #d5d5d5;
  }

  #demo .picture {
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  #demo .container {
    z-index: 99;
    position: fixed;
    // padding-top: 60px;
    left: 20%;
    top: 20%;
    right: 20%;
    bottom: 20%;
    background: rgba(0, 0, 0, 1);
  }

  #demo #image {
    max-width: 100%;
  }

  .cropper-view-box,
  .cropper-face {
    // border-radius: 50%;
  }

  /*!
 * Cropper.js v1.0.0-rc
 * https://github.com/fengyuanchen/cropperjs
 *
 * Copyright (c) 2017 Fengyuan Chen
 * Released under the MIT license
 *
 * Date: 2017-03-25T12:02:21.062Z
 */
  .cropper-container {
    font-size: 0;
    line-height: 0;
    position: relative;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    direction: ltr;
    -ms-touch-action: none;
    touch-action: none;
  }

  .cropper-container img {
    /* Avoid margin top issue (Occur only when margin-top <= -height) */
    display: block;
    min-width: 0 !important;
    max-width: none !important;
    min-height: 0 !important;
    max-height: none !important;
    width: 100%;
    height: 100%;
    image-orientation: 0deg;
  }

  .cropper-wrap-box,
  .cropper-canvas,
  .cropper-drag-box,
  .cropper-crop-box,
  .cropper-modal {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  .cropper-wrap-box {
    overflow: hidden;
  }

  .cropper-drag-box {
    opacity: 0;
    background-color: #fff;
  }

  .cropper-modal {
    opacity: 0.5;
    background-color: #000;
  }

  .cropper-view-box {
    display: block;
    overflow: hidden;
    width: 100%;
    height: 100%;
    outline: 1px solid #39f;
    outline-color: rgba(51, 153, 255, 0.75);
  }

  .cropper-dashed {
    position: absolute;
    display: block;
    opacity: 0.5;
    border: 0 dashed #eee;
  }

  .cropper-dashed.dashed-h {
    top: 33.33333%;
    left: 0;
    width: 100%;
    height: 33.33333%;
    border-top-width: 1px;
    border-bottom-width: 1px;
  }

  .cropper-dashed.dashed-v {
    top: 0;
    left: 33.33333%;
    width: 33.33333%;
    height: 100%;
    border-right-width: 1px;
    border-left-width: 1px;
  }

  .cropper-center {
    position: absolute;
    top: 50%;
    left: 50%;
    display: block;
    width: 0;
    height: 0;
    opacity: 0.75;
  }

  .cropper-center:before,
  .cropper-center:after {
    position: absolute;
    display: block;
    content: " ";
    background-color: #eee;
  }

  .cropper-center:before {
    top: 0;
    left: -3px;
    width: 7px;
    height: 1px;
  }

  .cropper-center:after {
    top: -3px;
    left: 0;
    width: 1px;
    height: 7px;
  }

  .cropper-face,
  .cropper-line,
  .cropper-point {
    position: absolute;
    display: block;
    width: 100%;
    height: 100%;
    opacity: 0.1;
  }

  .cropper-face {
    top: 0;
    left: 0;
    background-color: #fff;
  }

  .cropper-line {
    background-color: #39f;
  }

  .cropper-line.line-e {
    top: 0;
    right: -3px;
    width: 5px;
    cursor: e-resize;
  }

  .cropper-line.line-n {
    top: -3px;
    left: 0;
    height: 5px;
    cursor: n-resize;
  }

  .cropper-line.line-w {
    top: 0;
    left: -3px;
    width: 5px;
    cursor: w-resize;
  }

  .cropper-line.line-s {
    bottom: -3px;
    left: 0;
    height: 5px;
    cursor: s-resize;
  }

  .cropper-point {
    width: 5px;
    height: 5px;

    opacity: 0.75;
    background-color: #39f;
  }

  .cropper-point.point-e {
    top: 50%;
    right: -3px;
    margin-top: -3px;
    cursor: e-resize;
  }

  .cropper-point.point-n {
    top: -3px;
    left: 50%;
    margin-left: -3px;
    cursor: n-resize;
  }

  .cropper-point.point-w {
    top: 50%;
    left: -3px;
    margin-top: -3px;
    cursor: w-resize;
  }

  .cropper-point.point-s {
    bottom: -3px;
    left: 50%;
    margin-left: -3px;
    cursor: s-resize;
  }

  .cropper-point.point-ne {
    top: -3px;
    right: -3px;
    cursor: ne-resize;
  }

  .cropper-point.point-nw {
    top: -3px;
    left: -3px;
    cursor: nw-resize;
  }

  .cropper-point.point-sw {
    bottom: -3px;
    left: -3px;
    cursor: sw-resize;
  }

  .cropper-point.point-se {
    right: -3px;
    bottom: -3px;
    width: 20px;
    height: 20px;
    cursor: se-resize;
    opacity: 1;
  }

  @media (min-width: 768px) {
    .cropper-point.point-se {
      width: 15px;
      height: 15px;
    }
  }
  @media (min-width: 992px) {
    .cropper-point.point-se {
      width: 10px;
      height: 10px;
    }
  }
  @media (min-width: 1200px) {
    .cropper-point.point-se {
      width: 5px;
      height: 5px;
      opacity: 0.75;
    }
  }

  .cropper-point.point-se:before {
    position: absolute;
    right: -50%;
    bottom: -50%;
    display: block;
    width: 200%;
    height: 200%;
    content: " ";
    opacity: 0;
    background-color: #39f;
  }

  .cropper-invisible {
    opacity: 0;
  }

  .cropper-bg {
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC");
  }

  .cropper-hide {
    position: absolute;
    display: block;
    width: 0;
    height: 0;
  }

  .cropper-hidden {
    display: none !important;
  }

  .camera {
    width: 30px;
    height: 26px;
    display: block;
    margin-left: 30px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .cropper-move {
    cursor: move;
  }

  .cropper-crop {
    cursor: crosshair;
  }

  .cropper-disabled .cropper-drag-box,
  .cropper-disabled .cropper-face,
  .cropper-disabled .cropper-line,
  .cropper-disabled .cropper-point {
    cursor: not-allowed;
  }
}

.logo-title {
  font-size: 24px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.8);
  line-height: 28px;
  margin: 24px 0 24px 30px;
}

.logo-top {
  // height: 708px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.04);
  border-radius: 8px;
  // width: 680px;
  margin: 16px 0 0 20px;
  float: left;
}

.logo-topTitle {
  font-size: 16px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.8);
}

.logo-upload-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 100px;
  background: rgba(255, 255, 255, 1);
  border-radius: 3px;
  border: 1px dashed rgba(217, 217, 217, 1);
  margin-right: 24px;
  cursor: pointer;
  overflow: hidden;
}

.logo-upload-flexs {
  position: relative;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.6);
}

.logo-buyBrandConfig {
  position: absolute;
  left: 8px;
  top: 21px;
  width: 105px;
  height: 105px;
  background: transparent;
}

.logo-upload-white {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.8);
  line-height: 20px;
  margin: 0 24px;
}

.el-icon-plus {
  color: rgba(0, 0, 0, 0.26);
}

.logo-upload-boxImg img {
  width: 100%;
}

.cursion {
  cursor: pointer;
}

.logo-upload-title {
  margin-bottom: 8px;
}

.logo-upload-icon {
  font-weight: 400;
  color: rgba(0, 0, 0, 0.43);
  margin-top: 8px;
}

.logo-upload-iconpng {
  font-weight: 400;
  color: rgba(0, 0, 0, 0.43);
  margin-top: 4px;
}

.logo-top-flex {
  display: flex;
  align-items: center;
  // justify-content: center;
  // width: 632px;
  // height: 324px;
  // background-image: url("http://shuian-file.oss-cn-hangzhou.aliyuncs.com/user/logo-background.png");
  // background-size: cover;
  margin-left: 28px;
}

.logo-top-flexi {
  width: 234px;
  height: 73px;
  margin-right: 48px;
  // margin-left: 48px;
}

.logo-top-flexi img {
  width: 100%;
  height: 100%;
}

.cover-flex {
  display: flex;
}

.logo-topTitle-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 54px;
  line-height: 54px;
  padding-left: 24px;
  border-bottom: 1px solid rgba(238, 238, 238, 1);
  margin-bottom: 16px;
  padding-right: 24px;
  box-sizing: border-box;
}

.logo-btn {
  width: 76px;
  height: 32px;
  line-height: 32px;
  background: rgba(47, 84, 235, 1);
  border-radius: 3px;
  color: #fff;
  text-align: center;
  font-size: 14px;
  cursor: pointer;
}

.logo-btn:hover {
  background: rgba(47, 64, 235, 1);
}

.ease {
  transition: all 0.3s;
}

.cover-flex1 {
  flex: 1;
}

.logo-topTitle-flexTp {
  flex: 1;
}

.avatar {
  width: 100%;
  // object-fit: cover;
}

.avatar-uploader-iconadd {
  padding: 40px;
}

.logo-set-cover {
  position: relative;
  display: flex;
  align-items: flex-start;
  padding-bottom: 50px;
  // width: 49%;

  .cover-top {
    position: relative;
    width: 400px;
    margin-left: 20px;

    .background-cover-top {
      width: 400px;
    }

    .logo-cover-top {
      position: absolute;
      top: 30px;
      left: 30px;
      width: 100px;
      height: 100px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .logo-cover-top2 {
      // position: absolute;
      left: 50%;
      // top: 30px;
      transform: translate(-50%);
    }
    .logo-cover-top3 {
      right: 30px;
      left: auto;
    }
  }
}

.logo-reset-logo {
  margin-left: 20px;
}

.reset-tip {
  position: absolute;
  left: 16px;
  bottom: 16px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.8);
}

.avatar-cover {
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-set-cover-c {
  position: relative;
  display: flex;
  padding: 30px 0;
}

.logo-label {
  margin: 8px 0 0 28px;

  .label-name {
    margin-bottom: 4px;
  }

  .el-input {
    width: 320px;
  }

  .el-checkbox__input {
    line-height: auto;
  }
}

.logo-set-coverl {
  width: 52%;
}

.logo-set-coverr {
  width: 47%;
}

.cover-detected {
  position: absolute;
  left: 24px;
  top: 174px;
  font-size: 20px;
}
.heng{
  position: absolute;

  width:64px;
  height:4px;
  top: 222px;
  left: 24px;

  background:black;
}
.cover-detected-back {
  position: absolute;
  left: 24px;
  top: 228px;
  font-size: 42px;
  // background: -webkit-linear-gradient(#555ca7, #030852);
  // -webkit-text-fill-color: transparent;
  // -webkit-background-clip: text;
  // background-clip: text;
  white-space: nowrap;
  font-weight: bold;
}

.cover-report {
  position: absolute;
  left: 24px;
  top: 174px;
  font-size: 20px;
}

.logo-cover-detected2 {
  left: 50%;
  transform: translate(-50%);
}

.logo-cover-detected3 {
  right: 30px;
  left: auto;
}

.cover-detected-company {
  position: absolute;
  left: 24px;
  bottom: 30px;
  font-size: 16px;
}

.cover-time {
  position: absolute;
  left: 24px;
  bottom: 242px;
  font-size: 16px;
  color: #2f54eb;
}

.cover-white {
  color: #fff;
}

.logo-black {
  color: #000;
}
</style>
